import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GruppeTier } from '../../../../projects/kiene-core/src/lib/components/gruppe-tier/classes/gruppe-tier';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from '../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';

export interface PreiseFestlegenDialogInput {
    gruppeTiere: GruppeTier[];
}

@Component({
    selector: 'kiene-preise-festlegen-dialog',
    templateUrl: './preise-festlegen-dialog.component.html',
    styleUrls: ['./preise-festlegen-dialog.component.scss'],
})
export class PreiseFestlegenDialogComponent implements OnInit {
    preisCtrl = new FormControl<number | null>(null, [Validators.required, Validators.min(0)]);
    isLoading = false;

    constructor(
        public dialogRef: MatDialogRef<PreiseFestlegenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: PreiseFestlegenDialogInput,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneBackendApiService,
        private messageService: MessageService,
    ) {}

    ngOnInit(): void {}

    get anzahlTiere(): number {
        return this.data?.gruppeTiere?.length || 0;
    }

    close(): void {
        this.dialogRef.close();
    }

    save(): void {
        if (this.preisCtrl.invalid) {
            this.messageService.errorMessage('Bitte geben Sie einen gültigen Preis ein.', null);
            return;
        }

        const preis = this.preisCtrl.value;
        if (preis === null) {
            this.messageService.errorMessage('Bitte geben Sie einen Preis ein.', null);
            return;
        }

        this.isLoading = true;

        // Erstelle die Daten für die API
        const updateData = { gruppe_tiere: this.data.gruppeTiere.map(gt => ({ gt_id: gt.gt_id })), ek_brutto: preis };

        this.api.post(this.apiBaseUrl + 'gruppe_tier/update_preise_selektierte_tiere.php', updateData).subscribe({
            next: () => {
                this.messageService.infoMessage('Die Preise wurden erfolgreich gespeichert');
                this.dialogRef.close(true);
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Speichern der Preise', err);
                this.isLoading = false;
            },
        });
    }

    deletePrices(): void {
        this.isLoading = true;

        // Erstelle die Daten für die API - verwende die gleiche API wie beim Speichern, aber mit null als Preis
        const deleteData = { gruppe_tiere: this.data.gruppeTiere.map(gt => ({ gt_id: gt.gt_id })), ek_brutto: null };

        this.api.post(this.apiBaseUrl + 'gruppe_tier/update_preise_selektierte_tiere.php', deleteData).subscribe({
            next: () => {
                this.messageService.infoMessage('Die Preise wurden erfolgreich gelöscht');
                this.dialogRef.close(true);
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Löschen der Preise', err);
                this.isLoading = false;
            },
        });
    }
}
